import { checkPopup, setPopupFlag } from "@/api/dataset";

export default {
  namespaced: true,
  state: {
    isVisible: false,
  },
  mutations: {
    SET_VISIBLE(state: any, value: boolean) {
      state.isVisible = value;
    },
  },
  actions: {
    async showPopup({ commit }: any, payload: 0 | 1) {
      console.log("payload:", payload);
      const isLoggedIn = localStorage.getItem("token"); // 或其他判断用户登录状态的方法

      if (!isLoggedIn) {
        // 未登录逻辑：使用本地缓存
        // 更改逻辑：游客无法关闭，每次都弹
        // const hidePopup = localStorage.getItem("hidePopup");
        const lastShowTime = localStorage.getItem("lastPopupShowTime");
        const currentTime = Date.now();

        // 如果设置了永久不显示，则直接返回
        // if (hidePopup === "true") {
        //   return;
        // }
        if (payload === 0) {
          // 获取触发历史记录
          let triggerHistory = JSON.parse(
            localStorage.getItem("triggerHistory") || "[]"
          );

          // 清理超过10分钟的记录
          triggerHistory = triggerHistory.filter(
            (time: number) => currentTime - time < 10 * 60 * 1000
          );

          // 添加新的触发时间
          triggerHistory.push(currentTime);

          // 更新存储
          localStorage.setItem(
            "triggerHistory",
            JSON.stringify(triggerHistory)
          );

          // 如果10分钟内触发次数少于5次，直接返回
          if (triggerHistory.length < 5) {
            return;
          }
        }
        // 检查是否满足时间间隔（1小时）
        if (lastShowTime) {
          const timeDiff = currentTime - parseInt(lastShowTime);
          if (timeDiff < 60 * 60 * 1000) {
            return; // 如果间隔小于1小时，不显示
          }
        }

        // 更新显示时间并显示弹窗
        localStorage.setItem("lastPopupShowTime", currentTime.toString());
        localStorage.removeItem("triggerHistory");
        commit("SET_VISIBLE", true);
      } else {
        try {
          const shouldShow = await checkPopup(payload);
          if (shouldShow) {
            commit("SET_VISIBLE", true);
            setPopupFlag();
          }
        } catch (error) {
          console.error("Failed to get popup status:", error);
        }
      }
    },
    hidePopup({ commit }: any) {
      commit("SET_VISIBLE", false);
    },
  },
};
